module.exports = __webpack_public_path__ + "media/src/images/icons/download/red-2865595b5578d5167484846b6e7e1209.svg";